var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00047 7.82859L7.14531 7.68376C8.5304 6.29861 10.7761 6.29861 12.1612 7.68376C13.5464 9.06885 13.5464 11.3146 12.1612 12.6997L10.1549 14.706C8.7698 16.0912 6.52405 16.0912 5.13893 14.706C3.75382 13.3209 3.75382 11.0752 5.13893 9.6901L5.46398 9.36509",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    className: "only-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5362 8.12467L12.8612 7.79966C14.2463 6.41454 14.2463 4.16882 12.8612 2.78371C11.4761 1.3986 9.23035 1.3986 7.84526 2.78371L5.83888 4.79009C4.45377 6.1752 4.45377 8.42091 5.83888 9.806C7.224 11.1912 9.46975 11.1912 10.8548 9.806L10.9997 9.66117",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    className: "only-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.eacb7b53911d24147282da18bfe5982d.svg";
export { ForwardRef as ReactComponent };